import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";

export class ComponentAdapterPageBreak
  extends ComponentAdapterParent
  implements IComponentLoader
{
  private _showDescription: string = "";
  private _icon: string = "";
  private _mode: string = "";

  get ShowDescription(): string {
    return this._showDescription;
  }

  get Icon(): string {
    return this._icon;
  }

  get Mode(): string {
    return this._mode;
  }

  constructor() {
    super();
  }

  public fillProperty(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
  ): void {
    this._name =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.PAGE_BREAK_NAME,
      )?.value || "";
    this._description =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.PAGE_BREAK_DESCRIPTION,
      )?.value || "";
    this._showDescription =
      listSmartComponentSkills.find(
        (titleSkill) =>
          titleSkill.titleSkill === SkillNameList.PAGE_BREAK_SHOW_DESCRIPTION,
      )?.value || "";
    this._icon =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.PAGE_BREAK_ICON,
      )?.value || "";
    const idEnv = listSmartComponentSkills.find(
      (titleSkill) =>
        titleSkill.titleSkill === SkillNameList.PAGE_BREAK_ID_ENVIRONMENT,
    )?.value;
    if (idEnv) {
      this._idEnvironment = parseInt(idEnv);
    }
    this._mode =
      listSmartComponentSkills.find(
        (titleSkill) => titleSkill.titleSkill === SkillNameList.PAGE_BREAK_MODE,
      )?.value || "";

    this.fillMissingProperty();
    this.fillAddressState();
  }

  public fillMissingProperty(): void {}

  public fillAddressState(): void {}
}
